import axios from 'axios';
import { IGizmo, IIndex, IUserV2 } from '../../types';

interface IParams {
  gizmoConfig: IGizmo;
  rootGizmoFid: string;
  filterSearch?: string;
  textSearch?: string;
  page?: number;
  pageSize?: number;
  context: {
    apiUrl: string;
    user?: IUserV2;
  };
}

/**
 * Search filled forms on the server, there are two modes of searching:
 * 	- fluxSearch: a flux query expression will be evaluated on the server
 * 	- textSearch: a text is send to the server and the collection textSearch configuration will
 * 			determine the results.
 *
 * @param {IGizmo} gizmoConfig gizmo configuration of the Gizmo that's triggering the search
 * @param {string} filterSearch interpolated filter, this was done on the Gizmo
 *
 * @returns {IFilledFormsIndex} index with the results of the search
 */
function searchFilledForms({
  gizmoConfig,
  rootGizmoFid,
  filterSearch,
  textSearch,
  page,
  pageSize,
  context,
}: IParams): Promise<IIndex> {
  return new Promise<IIndex>(async (resolve, reject) => {
    const { apiUrl, user } = context;
    const config: any = gizmoConfig;
    config.options = config.ops;

    const requestData: any = {
      gizmo: config,
      rootGizmoFid,
    };

    // Depending on the key arriving we're going to add it to the requestData
    if (filterSearch) {
      requestData['filter'] = filterSearch;
    }
    if (textSearch) {
      requestData['text'] = textSearch;
    }
    if (page) {
      requestData['page'] = page;
    }
    if (pageSize) {
      requestData['pageSize'] = pageSize;
    }

    if (
      config.ops?.search?.rootGizmoFid &&
      config.ops.search.minChars &&
      config.ops.search.rootGizmoFid &&
      (filterSearch || textSearch)
    ) {
      const index: IIndex = {
        fid: 'search',
        columns: [],
        rows: [],
      };

      try {
        const credentials: any = user?.credentials;
        const url = `${apiUrl}/main_api/v1/search/root_gizmo/data/${config.ops.search.rootGizmoFid}`;
        // const url = `${apiUrl}/main_api/v1/public/search/root_gizmo/data/${config.ops.search.rootGizmoFid}`;
        const response = await axios({
          method: 'POST',
          url,
          data: requestData,
          headers: {
            ...credentials,
          },
        });

        if (response.status === 200) {
          const { data } = response;

          if (response.headers) {
            const total = +response.headers['x-total'];
            const pageFromServer = +response.headers['x-page'];
            const pageSizeFromServer = +response.headers['x-per-page'];

            index.pagination = {
              page: pageFromServer,
              pageSize: pageSizeFromServer,
              total,
            };
          }

          if (data.filledForms && Array.isArray(data.filledForms)) {
            for (const filledForm of data.filledForms) {
              index.rows.push(filledForm);
            }
          }
        }
      } catch (e) {
        reject(e);
      }

      return resolve(index);
    }

    reject();
  });
}

export default searchFilledForms;
